<template>
  <div class="text-button" onselectstart="return false">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    icon: String
  }
})
export default class TextButton extends Vue {
  icon!: string
}
</script>

<style scoped lang="scss">
.text-button {
  color: $text-light;
  padding: 0em;
  cursor: pointer;

}

</style>
